import { render, staticRenderFns } from "./CanvasPin.vue?vue&type=template&id=15899925&"
import script from "./CanvasPin.vue?vue&type=script&lang=js&"
export * from "./CanvasPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports